module.exports = __webpack_public_path__ + "res/Roboto-MediumItalic-webfontd41d.eot?bcaffef1a7ab1064a99730dba794f3ad";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-MediumItalic-webfontd41d.eot
// module id = 77
// module chunks = 0